import { defineComponent as _defineComponent } from 'vue'
import { activityList } from "@/api/php/me";
import { cheackQuery, nativeToNewWeb, ToBack, toLocationBrowser } from "@/uitls/native";
import { Toast } from "vant";
import { ref, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useI18n } from 'vue-i18n'
import { storeToRefs } from "pinia";
import { serverConfigPiniaState } from "@/store/serverConfig";

export default /*#__PURE__*/_defineComponent({
  name: 'ActivityPage',
  setup(__props, { expose }) {
  expose();

const ConfigpiniaStore = serverConfigPiniaState();
const { configNoticebarTextTo } = storeToRefs(ConfigpiniaStore);
// configNoticebarTextTo
const { t } = useI18n()
const commentIcon = require("@/assets/images/pinglun_icon.png");
const zanIcon = require("@/assets/images/dianzan_icon.png");
const router = useRouter();
const route = useRoute();

const th = process.env.VUE_APP_Language as string;
const isTh = ref(false)

onMounted(() => {
    if (th == 'th') {
        isTh.value = true
    }
    cheackQuery(route); 
    // getData()
})
const page = ref(0);
const listData = ref([]);
const getData = async (onRefresh = false) => {
    const res: any = await activityList({
        page: page.value, limit: 10
    })
    console.log(res);
    

    if (res && res.code == 200) {
        if (onRefresh) {
            listData.value = res.data.list;
        } else {
            listData.value = [...listData.value, ...res.data.list]
        }
        if (res.data.list.length < 10) {
            finished.value = true;
        }

    }
    loading.value = false;

}
const loading = ref(false);
const onRefresh = () => {
    page.value = 1;
    finished.value = false;
    getData(true)

};
const finished = ref(false);
const onLoad = () => {
    page.value++;
    getData()
};
// activityDetail
const toDetail = (data) => {
    window.$apiNet.statisticsPost({ action_id: 24 });
    if (data.other_type == 1) {
        nativeToNewWeb(router, `/invitef?a=b`)
        return ;
    }
    if (data.other_type == 2) {
        // toLocationBrowser(data.url + '/?website=' + configNoticebarTextTo.value)
        toLocationBrowser(data.url)
        return ;
    }
    const id = data.id;
    nativeToNewWeb(router, `/activityDetail?id=${id}`)
}



const __returned__ = { ConfigpiniaStore, configNoticebarTextTo, t, commentIcon, zanIcon, router, route, th, isTh, page, listData, getData, loading, onRefresh, finished, onLoad, toDetail, ToBack }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})